



















































































import Currency from "@/store/entities/currency";
import { Component, Vue } from "vue-property-decorator";
import AddCurrency from "./modals/addCurrency.vue";

@Component({
  components: { AddCurrency },
})
export default class Currencies extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  currencies: Currency[] = [];

  created() {
    this.getCurrencies();
    (this.headers = [
      { text: "ID", value: "id" },
      { text: "İsim", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          id: "A",
          name: "Y",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Para Birimleri", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }

  editCurrency(item) {
    this.$store.state.currency.editCurrency = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.currency.editCurrency = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getCurrencies();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
